module.exports = __webpack_public_path__ + "static/Login-page-7aca2a463eb1d0dc7290b14c5e6b6348.jpg";